var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.25,
    viewBox: "0 0 24 21.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Caminho_14506",
    "data-name": "Caminho 14506",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66,0H20.34C22.361,0,24,1.369,24,3.058V18.192c0,1.689-1.639,3.058-3.66,3.058H3.66C1.639,21.25,0,19.881,0,18.192V3.058C0,1.369,1.639,0,3.66,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.659940719604492 2 C 2.709890365600586 2 2.000001907348633 2.558340072631836 2.000001907348633 3.057559967041016 L 2.000001907348633 18.19244003295898 C 2.000001907348633 18.69165992736816 2.709890365600586 19.25 3.659940719604492 19.25 L 20.34006118774414 19.25 C 21.29011154174805 19.25 22 18.69165992736816 22 18.19244003295898 L 22 3.057559967041016 C 22 2.558340072631836 21.29011154174805 2 20.34006118774414 2 L 3.659940719604492 2 M 3.659940719604492 0 L 20.34006118774414 0 C 22.36139106750488 0 24 1.368919372558594 24 3.057559967041016 L 24 18.19244003295898 C 24 19.88108062744141 22.36139106750488 21.25 20.34006118774414 21.25 L 3.659940719604492 21.25 C 1.63861083984375 21.25 1.9073486328125e-06 19.88108062744141 1.9073486328125e-06 18.19244003295898 L 1.9073486328125e-06 3.057559967041016 C 1.9073486328125e-06 1.368919372558594 1.63861083984375 0 3.659940719604492 0 Z",
    stroke: "none",
    fill: "#a6abaf"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_15_Chat",
    "data-name": "15 Chat",
    transform: "translate(5.889 5.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14430",
    "data-name": "Caminho 14430",
    d: "M6.12,116.683H.561a.561.561,0,0,1,0-1.123H6.12a.561.561,0,0,1,0,1.123Z",
    transform: "translate(0 -113.855)",
    fill: "#a6abaf",
    stroke: "#a6abaf",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14431",
    "data-name": "Caminho 14431",
    d: "M401.386,116.683h-1.4a.561.561,0,1,1,0-1.123h1.4a.561.561,0,1,1,0,1.123Z",
    transform: "translate(-390.452 -113.855)",
    fill: "#a6abaf",
    stroke: "#a6abaf",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14432",
    "data-name": "Caminho 14432",
    d: "M220.55,347.563h-5.558a.561.561,0,1,1,0-1.123h5.558a.561.561,0,0,1,0,1.123Z",
    transform: "translate(-209.616 -339.552)",
    fill: "#a6abaf",
    stroke: "#a6abaf",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14433",
    "data-name": "Caminho 14433",
    d: "M1.966,347.563H.561a.561.561,0,0,1,0-1.123H1.966a.561.561,0,0,1,0,1.123Z",
    transform: "translate(0 -339.552)",
    fill: "#a6abaf",
    stroke: "#a6abaf",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14434",
    "data-name": "Caminho 14434",
    d: "M64.836,273.192a2.266,2.266,0,1,1,2.266-2.266A2.266,2.266,0,0,1,64.836,273.192Zm0-3.409a1.143,1.143,0,1,0,1.143,1.143A1.143,1.143,0,0,0,64.836,269.783Z",
    transform: "translate(-61.165 -263.518)",
    fill: "#a6abaf",
    stroke: "#a6abaf",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14435",
    "data-name": "Caminho 14435",
    d: "M249.826,44.162a2.266,2.266,0,1,1,2.266-2.266A2.266,2.266,0,0,1,249.826,44.162Zm0-3.409A1.143,1.143,0,1,0,250.97,41.9,1.143,1.143,0,0,0,249.826,40.753Z",
    transform: "translate(-242.002 -39.63)",
    fill: "#a6abaf",
    stroke: "#a6abaf",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSettings);
export default __webpack_public_path__ + "static/media/ic-settings.3ce9afb3a9e0f40ae1113cb1b4474453.svg";
export { ForwardRef as ReactComponent };